import React from 'react';
import PropTypes from 'prop-types';
import { useUID } from 'dibs-uid';
import { getSrcString, getSrcSetString } from '../helpers/getSrcStrings';

import styles from './HpRespHeroModuleItemOld.scss';

function HpRespHeroModuleItemOld({ item, isVisible, onClick }) {
    const { imageUrl, title, link } = item;
    const uid = useUID() || undefined;
    const heroModuleId = `heromodule-${uid}`;
    return (
        <a
            data-tn="hero-item-link"
            href={link}
            className={styles.heroItem}
            style={{ opacity: isVisible ? '1' : '0' }}
            onClick={onClick}
        >
            <div className={styles.imageWrapper}>
                <img
                    aria-labelledby={heroModuleId}
                    className={styles.image}
                    src={getSrcString({ url: imageUrl })}
                    data-tn="hero-item-image"
                    srcSet={getSrcSetString({
                        url: imageUrl,
                        widths: [200, 240],
                    })}
                />
            </div>
            <div
                id={heroModuleId}
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: title }}
                data-tn="hero-item-title"
            />
        </a>
    );
}

HpRespHeroModuleItemOld.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        link: PropTypes.string,
    }).isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

HpRespHeroModuleItemOld.defaultProps = {
    isVisible: true,
};

export { HpRespHeroModuleItemOld };
